import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
// As we are using createAsynThunk, so we are writing our actions separately to provide them in extraReducers

// Delete commercial payment methods
export const deleteCommercialPayement = createAsyncThunk(
  "commercial/deletePayment",
  async (item: any): Promise<any> => {
    try {
      const res = await ax.delete<IApi>(
        `/delete-payment-by-id/${item.paymentId}?serialNo=${item.serialNumber}&regNo=${item.registrationNumber}&gatePassId=${item.gatePassId}&remarks=${item.deleteRemarks}`
      );
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const voidCommercialPayement = createAsyncThunk(
  "commercial/voidPayment",
  async (paymentId: any): Promise<any> => {
    try {
      const res = await ax.put<IApi>("update-invoice-status", { paymentId: paymentId });
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getPaymentTypesDropdownAction = createAsyncThunk(
  "commercial/getPaymentTypesDropdownAction", // action string
  async () => {
    try {
      const res = await ax.get<IApi>(
        "/get-all-payment-type?showSystemFields=true&ShowIsActve=true"
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getScanWeightType = createAsyncThunk(
  "commercial/getScanWeightType", // action string
  async (vehicleId: any) => {
    try {
      const res = await ax.get<IApi>(`/get-scan-weight-types-by-vehicle-id/${vehicleId}`);
      if (res.data.isSuccess === true && res.data.value.gatePassWeightScan)
        return res.data.value.gatePassWeightScan;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getPaymentTypeDetailsAction = createAsyncThunk(
  "commercial/getPaymentTypeDetails", // action string
  async (id: any) => {
    try {
      const res = await ax.get<IApi>(`/get-payment-type-by-id/${id}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const postTerminalChargesWholeRecordAction = createAsyncThunk(
  "gate-entry/postTerminalChargesWholeRecordAction", // action string
  async (record: any) => {
    try {
      const res = await ax.post<IApi>("/create-payment", record);
      if (res.data.isSuccess === true && res.data.value) {
        return res.data.value;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getPaymentDetailsById = createAsyncThunk(
  "configuration/getPaymentDetailsById", // action string
  async (id: number) => {
    try {
      const res = await ax.get<IApi>(`/get-all-payment-received-history-by-payment-id/${id}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const addPaymentReceivedDrawer = createAsyncThunk(
  "commercial/addPaymentReceivedDrawer", // action string
  async ({
    gatePassPaymentId,
    registerationNumber,
    paymentDate,
    amount,
    currency,
    paymentMethod,
    remarks,
    fileRecord,
    vehicleId,
  }: {
    gatePassPaymentId: string;
    registerationNumber: string;
    paymentDate: string;
    amount: string;
    currency: string;
    paymentMethod: string;
    remarks: string;
    fileRecord: File;
    vehicleId?: string;
  }): Promise<boolean> => {
    const form = new FormData();
    form.append("gatePassPaymentId", gatePassPaymentId);
    form.append("registerationNumber", registerationNumber);
    form.append("paymentDate", paymentDate);
    form.append("amount", amount);
    form.append("currency", currency);
    form.append("paymentMethod", paymentMethod);
    form.append("remarks", remarks);
    form.append("file", fileRecord);
    form.append("vehicleId", vehicleId == undefined ? "" : vehicleId);

    try {
      const res = await ax.post<IApi>("/create-payment-received", form);
      if (res.data.isSuccess === true && res.data.value) {
        return res.data.value;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
